import React, { Component } from 'react'
 class SecondComponent extends Component {
    render(){
    return (
      <div className="secondCompnent">
            HELLO WONDERFUL PEOPLE !!!!....
      </div>
    )
  }
  }
  export default SecondComponent